import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/vercel/path0/frontend/components/auth/AuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QueryProvider"] */ "/vercel/path0/frontend/lib/query/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/node_modules/.pnpm/next-intl@4.9.1_next@15.5.14_@babel+core@7.29.0_@opentelemetry+api@1.9.1_@playwright+te_983b771dfce097166caf12242b463f56/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
